export default __webpack_public_path__ + "static/media/pancakeswap.cf4837c7.svg";